
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Transaction from '@/extend/classes/Transaction';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeTransaction' })

export default class storeTransaction extends VuexModule {
  // States
  private reccords: Transaction[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get transactionLoading (): boolean {
    return this.dataLoading;
  }
  private get transactionRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get transactionLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewTransaction() {
    return (): Transaction => { 
      return this.getTransaction(0, true);
    }
  }

  
  public get getTransaction () {
    return (id: number, canCreate = false): Transaction => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Transaction can't be 0")
        return new Transaction();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Transaction();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Transaction.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromTransaction(data.reccords[0] as Transaction);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listTransaction (): Transaction[] {
    return this.reccords;
  }

  public get listConfigTransaction (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mTransactionRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mTransactionClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mTransactionLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mTransactionLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Transaction.fromJson(reccord as Transaction));
    })
    Transaction.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mTransactionConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mTransactionCreated (obj: Transaction): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareTransaction(obj)) {
          api.fromTransaction(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareTransaction(obj)) {
            api.fromTransaction(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mTransactionUpdated (obj: Transaction): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareTransaction(obj)) {
          api.fromTransaction(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mTransactionDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerTransaction (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.transactionRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerTransaction(this.transactionCreated, this.transactionUpdated, this.transactionDeleted);
          this.mTransactionRegistered();
        } else {
          setTimeout(() => resolve(this.registerTransaction(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.transactionLoading && !this.transactionLoaded) {
          this.mTransactionLoading(true);
          return Transaction.list(filter)
            .then((data: ListData) => {
              this.mTransactionLoaded(data);
              this.mTransactionLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredTransaction (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.transactionLoading) {
        this.mTransactionLoading(true);
        return Transaction.list(filter)
          .then((data: ListData) => {
            this.mTransactionLoaded(data);
            this.mTransactionLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createTransaction (obj: Transaction): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      return Transaction.fromJson(obj).createForStoreTransaction()
        .then((reccords) => {
          this.mTransactionCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateTransaction (obj: Transaction): Promise<Transaction> {
    return new Promise((resolve, reject) => {
      return Transaction.fromJson(obj).updateForStoreTransaction()
        .then((reccords) => {
          this.mTransactionUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  private transactionCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mTransactionConfigUpdated(config)
    const obj = objConfig.obj as Transaction;
    this.mTransactionCreated(Transaction.fromJson(obj));
  }

  @Action
  private transactionUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mTransactionConfigUpdated(config)
    const obj = objConfig.obj as Transaction;
    this.mTransactionUpdated(Transaction.fromJson(obj));
  }

  @Action
  private transactionDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Transaction;
    this.mTransactionDeleted(obj.id);
  }
}
